import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import {
  Btns,
  ButtonL,
  Content,
  ImgWrap,
  Section,
  TextDiv,
} from "../styles/Common";
import { styled } from "styled-components";
import resultImg from "../styles/images/img_point_change_result.png";
import PointBanner from "../components/pointChange/PointBanner";
import OnePageLayout from "../components/layout/OnePageLayout";
import { useSelector } from "react-redux";
import { replaceCommas } from "../components/hooks/basicFunc";
import OnlyHeaderLayout from "../components/layout/OnlyHeaderLayout";

const PointChangeResultPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const pointExchangeResult = useSelector(
    (state) => state.point.pointExchangeResult
  );
  // const [changePoint, setChangePoint] = useState(pointExchangeResult.point);
  const target = location.state !== null ? location.state.target : "";
  const changePoint = location.state !== null ? location.state.changePoint : "";
  const changedMup = location.state !== null ? location.state.changedMup : "";

  return (
    <OnlyHeaderLayout title="포인트 교환">
      <PointChangeSection>
        <div>
          <PointBanner
            changedPoint={pointExchangeResult.exchangeMup}
            mup={pointExchangeResult.mup}
          />
          <PointChangeContent>
            <PointChangeTextDiv>
              <h3>포인트 교환을 완료했습니다.</h3>
              <h3>
                {target}
                <span className="col">{replaceCommas(changePoint)}</span>{" "}
                포인트를
                <br />뮤 포인트로 교환하였습니다.
              </h3>
            </PointChangeTextDiv>
            <ImgWrap>
              <img src={resultImg} alt="" />
            </ImgWrap>
            <NavLink
              to={"/mypage/point"}
              // onClick={() => window.location.replace("/mypage/point")}
            >
              교환 내역 확인 (MY 포인트)
            </NavLink>
          </PointChangeContent>
        </div>
        <Btns>
          <ButtonL
            onClick={() => {
              // navigate("/home", { replace: true });
              window.location.replace("/point/change");
            }}
          >
            확인
          </ButtonL>
        </Btns>
      </PointChangeSection>
    </OnlyHeaderLayout>
  );
};

export default PointChangeResultPage;

const PointChangeSection = styled(Section)`
  padding-top: 0;
`;
const PointChangeContent = styled(Content)`
  text-align: center;
  img {
    margin-top: 6rem;
    width: 21.8rem;
  }
  a {
    margin-top: 3rem;
    display: inline-block;
    color: ${({ theme }) => theme.color.purple_secondary};
    margin-top: 3rem;
    text-align: center;
    font-weight: 700;
    font-size: 1.4rem;
    line-height: 2rem; /* 142.857% */
    letter-spacing: -0.42px;
    text-decoration-line: underline;
  }
`;
const PointChangeTextDiv = styled(TextDiv)`
  margin-top: 4rem;
  h3 {
    letter-spacing: -0.48px;
    span {
      margin-left: 0.6rem;
      font-family: NanumSquareEB;
    }
    &:nth-of-type(2) {
      margin-top: 3rem;
      color: ${({ theme }) => theme.color.purple_primary};
    }
  }
  p {
    letter-spacing: -0.42px;
    margin-top: 1.5rem;
  }
`;
